
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../components/Footer'
import Mainmenu from '../../components/Mainmenu'
import Navbar from '../../components/Navbar'
import { getDefaultName, mediaSrc } from '../../utils'
import { HttpService } from '../../utils/http'
import {ApiHttpService} from '../../utils/http/api'

const DEFAULT_IMAGE = '/assets/images/default.png';

function CourseHistory() {
    const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [course_histories, setCourseHistories] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [pages, setPages] = useState(null);

  var urlParams = ""
  const pageParam = typeof window !== "undefined"
    ? parseInt(new URLSearchParams(window.location.search).get("page") || "1", 10)
    : 1;
  var page = Number.isNaN(pageParam) || pageParam < 1 ? 1 : pageParam;

  useEffect(() => {
    setPageLoading(true);
    getData();

    
  }, []);

  async function getData() {
    try {
      const data = await ApiHttpService.loadCourseHistories(page);
      const list = data?.results || [];

      const enrichedList = await Promise.all(
        list.map(async (item) => {
          if (item?.image || item?.image_url) return item;
          try {
            const details = await ApiHttpService.loadCourseHistory(item.id);
            return {
              ...item,
              image: details?.image || item?.image || null,
            };
          } catch (e) {
            return item;
          }
        })
      );

      setCourseHistories(enrichedList);

      if (data && data.count) {
        var page_count =
          data.count % 10 === 0
            ? parseInt(data.count / 10)
            : parseInt(data.count / 10) + 1;
        var pages_array = range(1, page_count);
        setPages(pages_array);
      }
    } finally {
      setPageLoading(false);
    }
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
    var service = new HttpService();
    service.delete(`api/coursehistory/${id}`).then(()=>{
        setLoading(false);
        setCourseHistories(course_histories.filter(item=>item.id!=id))
    })
   
  };

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete);
  };

  return (
    <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <div className="content-wrapper">
            <section class="content-header">
            <h3 class="box-title mt-5"></h3>
            </section>

            <section className="content">
            <div className="row">
                <div className="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                    <h3 class="box-title mt-5">
                        Contest History &nbsp;
                    </h3>
                    <a href="/cms/coursehistory" title="Create new history" className="btn btn-cm pull-right "><i className="fa fa-plus"></i></a>
                    <a
                        href="/cms/delete"
                        title="Show Delete Button"
                        className="btn btn-cm margin-r-5 pull-right "
                         onClick={showDelete}
                    >
                        <i className="fa fa-trash"></i>
                    </a>
                    </div>
                    <div className="box-body">
                      {pageloading && (
                        <p className="text-center" style={{ color: '#7a9ab8' }}>Loading…</p>
                      )}
                      <div className="talent-cards-grid course-cards-grid">
                        {course_histories?.map((item, index) => (
                          <div
                            key={item.id}
                            className={`talent-card-col ${loading === item.id ? "loading" : ""}`}
                            style={{ animationDelay: `${Math.min(index * 42, 480)}ms` }}
                          >
                            <div className="talent-card course-card-item">
                              {show_delete && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-xs course-card-delete-btn"
                                  onClick={(e) => {
                                    if (window.confirm("Are you sure you wish to delete this item?")) {
                                      handleDelete(item.id, e);
                                    }
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              )}
                              <a href={`/cms/coursehistory/${item.id}`} className="course-card-media">
                                <img
                                  className="talent-card-img"
                                  src={mediaSrc(
                                    item?.image_url ||
                                      item?.image ||
                                      item?.course?.image_url ||
                                      item?.course?.image,
                                    DEFAULT_IMAGE
                                  )}
                                  alt={getDefaultName(item.names)}
                                />
                              </a>
                              <a href={`/cms/coursehistory/${item.id}`} className="course-card-title-link">
                                {getDefaultName(item.names)}
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                </div>
                {pages && pages.length > 1 &&
                <ul className="pagination cms-pagination m-0 float-right">
                    <li className="page-item">
                    <Link className="page-link" to="#">
                        «
                    </Link>
                    </li>
                    
                    {pages.map((page_number) => (
                        <li key={page_number} className="page-item">
                        <a
                            className={
                            page_number == page ? "page-link active" : "page-link"
                            }
                            href={`/cms/coursehistories?page=${page_number}${
                              urlParams ? "&" + urlParams : ""
                            }`}
                        >
                            {page_number}
                        </a>
                        </li>
                    ))}
                    <li className="page-item">
                    <Link className="page-link" to="">
                        »
                    </Link>
                    </li>
                </ul>
                }
                </div>
            </div>
            </section>
        </div>
        <Footer />

    </div>
  )
}

export default CourseHistory
